import { dataHooks } from '@wix/data-hooks';

export const topConvertingTemplateDataHooks = dataHooks<{
  viewButton: { key: string };
  editButton: { key: string };
}>('top-converting-template');
